// const CURRENCY_OPTIONS = [
//   { label: "Indian Rupee (INR)", value: "INR" },
//   { label: "US Dollar (USD)", value: "USD" },
//   { label: "Euro (EUR)", value: "EUR" },
//   { label: "British Pound (GBP)", value: "GBP" },
//   { label: "Australian Dollar (AUD)", value: "AUD" },
//   { label: "Canadian Dollar (CAD)", value: "CAD" },
//   { label: "Singapore Dollar (SGD)", value: "SGD" },
//   { label: "UAE Dirham (AED)", value: "AED" },
// ];

const currencyCodes = [
  "AED","AFN","ALL","AMD","ANG","AOA","ARS","AUD","AWG","AZN",
  "BAM","BBD","BDT","BGN","BHD","BIF","BMD","BND","BOB","BRL",
  "BSD","BTN","BWP","BYN","BZD",
  "CAD","CDF","CHF","CLP","CNY","COP","CRC","CUP","CVE","CZK",
  "DJF","DKK","DOP","DZD",
  "EGP","ERN","ETB","EUR",
  "FJD","FKP",
  "GBP","GEL","GHS","GIP","GMD","GNF","GTQ","GYD",
  "HKD","HNL","HRK","HTG","HUF",
  "IDR","ILS","INR","IQD","IRR","ISK",
  "JMD","JOD","JPY",
  "KES","KGS","KHR","KMF","KRW","KWD","KYD","KZT",
  "LAK","LBP","LKR","LRD","LSL","LYD",
  "MAD","MDL","MGA","MKD","MMK","MNT","MOP","MRU","MUR","MVR",
  "MWK","MXN","MYR","MZN",
  "NAD","NGN","NIO","NOK","NPR","NZD",
  "OMR",
  "PAB","PEN","PGK","PHP","PKR","PLN","PYG",
  "QAR",
  "RON","RSD","RUB","RWF",
  "SAR","SBD","SCR","SDG","SEK","SGD","SHP","SLL","SOS","SRD",
  "SSP","STN","SVC","SYP","SZL",
  "THB","TJS","TMT","TND","TOP","TRY","TTD","TWD","TZS",
  "UAH","UGX","USD","UYU","UZS",
  "VES","VND","VUV",
  "WST",
  "XAF","XCD","XOF","XPF",
  "YER",
  "ZAR","ZMW","ZWL"
];


const CURRENCY_OPTIONS = currencyCodes.map(code => ({
  value: code,
  label: `${new Intl.DisplayNames(["en"], { type: "currency" }).of(code)} (${code})`
}));


export default CURRENCY_OPTIONS